import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { KindergartenService } from '@app/core/services/kindergarten.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-workplace-info',
    templateUrl: './workplace-info.component.html',
    styleUrls: ['./workplace-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WorkplaceInfoComponent {
  private kindergartenService = inject(KindergartenService);

  workplaceName$ = this.kindergartenService.kindergarten$.pipe(
    map(k => k?.name)
  );

  showMessage$ = new BehaviorSubject(false);

  constructor() {
    this.kindergartenService.kindergarten$.subscribe(k => {
      if (k?.isPrimary) {
        this.showMessage$.next(true);
        setTimeout(() => this.showMessage$.next(false), 3000);
      } else {
        this.showMessage$.next(false);
      }
    });
  }
}
